export default "__VITE_ASSET__CEaF8LIb__"